module.exports = __webpack_public_path__ + "static/media/open-book-board.ee59b7b5.png";